module.exports = __webpack_public_path__ + "img/食品备案-加水印.eaf873e1.png";